import * as z from "zod";

/** Whether Commerce Agent can text from this team's Recover sender. */
export const getRecoverSmsSenderReady = {
  name: "getRecoverSmsSenderReady" as const,
  input: z.object({}),
  output: z.object({ ready: z.boolean() }),
};
